import React, { useEffect, useRef } from 'react';
import { Terminal, Loader2, CheckCircle, XCircle, ExternalLink, X } from 'lucide-react';

const LEVEL_COLOR = { info: 'text-slate-300', success: 'text-emerald-400', warn: 'text-amber-300', error: 'text-red-400' };

export const DeployLogConsole = ({ job, onClose }) => {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ block: 'nearest' }); }, [job?.logs?.length]);
  if (!job) return null;
  const running = job.status === 'running';

  return (
    <div className="bg-slate-950 border border-slate-700 rounded-xl overflow-hidden" data-testid="deploy-log-console">
      <div className="px-4 py-3 border-b border-slate-800 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm">
          <Terminal className="w-4 h-4 text-purple-400" />
          <span className="text-white font-medium">{job.contract_type} → {job.network}</span>
          <span className="text-slate-500 font-mono text-xs">{job.job_id}</span>
        </div>
        <div className="flex items-center gap-3">
          <span data-testid="deploy-log-status" className={`flex items-center gap-1 text-xs font-medium ${running ? 'text-amber-300' : ['deployed', 'completed'].includes(job.status) ? 'text-emerald-400' : 'text-red-400'}`}>
            {running ? <Loader2 className="w-3 h-3 animate-spin" /> : ['deployed', 'completed'].includes(job.status) ? <CheckCircle className="w-3 h-3" /> : <XCircle className="w-3 h-3" />}
            {job.status}
          </span>
          {!running && (
            <button onClick={onClose} data-testid="deploy-log-close-btn" className="text-slate-500 hover:text-white"><X className="w-4 h-4" /></button>
          )}
        </div>
      </div>
      <div className="p-4 max-h-72 overflow-y-auto font-mono text-xs space-y-1" data-testid="deploy-log-lines">
        {(job.logs || []).map((l, i) => (
          <div key={i} className="flex gap-3">
            <span className="text-slate-600 shrink-0">{new Date(l.t).toLocaleTimeString()}</span>
            <span className={`${LEVEL_COLOR[l.level] || LEVEL_COLOR.info} break-all`}>{l.msg}</span>
          </div>
        ))}
        {running && <div className="text-slate-500 animate-pulse">▍</div>}
        <div ref={endRef} />
      </div>
      {job.explorer_url && (
        <a href={job.explorer_url} target="_blank" rel="noreferrer" data-testid="deploy-log-explorer-link"
          className="block px-4 py-2 border-t border-slate-800 text-xs text-blue-400 hover:text-blue-300 flex items-center gap-1">
          <ExternalLink className="w-3 h-3" /> View {job.contract_address} on Etherscan
        </a>
      )}
    </div>
  );
};

export default DeployLogConsole;
